import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import {
    CourseSubjectPricePurchaseState,
    SelectedPurchaseSubjectState,
} from '../../../../../../features/types'
import { flexWrap, tabTitle } from '../../style'
import { SelectedSubjectState } from '../../types'
import SelectSubjectCard from './SelectSubjectCard'

interface Props {
    subjects: SelectedPurchaseSubjectState[]
    courseSubjectPrices: CourseSubjectPricePurchaseState[]
    onSubjectClick: (
        subject: SelectedPurchaseSubjectState,
        courseSubjectPrice: CourseSubjectPricePurchaseState,
    ) => void
    selectedSubjects: SelectedSubjectState[]
    duration: number
}

const SelectSubjectTab: React.FC<Props> = ({
    courseSubjectPrices,
    subjects,
    duration,
    onSubjectClick,
    selectedSubjects,
}) => {
    const { formatMessage } = useIntl()

    const getCourseSubjectPrice = (subject: SelectedPurchaseSubjectState) => {
        const courseSubjectPrice = courseSubjectPrices?.find(
            (price) => price.courseSubjectId === subject.courseSubjectId,
        )

        return courseSubjectPrice
    }

    return (
        <Box>
            <Box sx={tabTitle}>{formatMessage({ id: 'chooseSubject' })}</Box>

            <Box sx={flexWrap}>
                {subjects.map((subject) => (
                    <SelectSubjectCard
                        key={subject.id}
                        duration={duration}
                        selected={selectedSubjects.some(
                            (selectedSubject) =>
                                selectedSubject.id == subject.id,
                        )}
                        courseSubjectPrice={getCourseSubjectPrice(subject)}
                        subject={subject}
                        onSubjectClick={onSubjectClick}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default SelectSubjectTab
